// LoginPage.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  TextField,
  Button,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  Paper,
  Alert 
} from '@mui/material';
import { MicrosoftSSOButton } from './MicrosoftSSOButton';
import { useAuthSession } from './AuthSessionContext';



function LoginPage() {
  // const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');
  const { user, loading } = useAuthSession();
  const isAuthenticated = Boolean(user);
  



  // const { instance, inProgress } = useMsal();
  // const isAuthenticated = useIsAuthenticated();
  // const [error, setError] = useState("");
  const loginSSO = () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL || '';
    window.location.href = `${baseUrl}/api/v1/auth/login?next=${encodeURIComponent(window.location.origin)}`;
  };

  useEffect(() => {
    if (isAuthenticated) {
      console.log("Authenticated & navigating...");
      navigate('/')
    
    } else {
      console.log("Not authenticated...");
    
    }

  }, [isAuthenticated]);

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    return
    // const { success, role } = login(username, password, rememberMe);
    // await instance.acquireTokenRedirect({
    //   ...loginRequest,
    //   account: accounts[0],
    // }).then(async (e) => {
    //   await instance.logout();
    //   console.log()
    // }).catch((e) => {
    //   console.error('Token acquisition via redirect failed:', e);
    // });
    
    const success = true;
    const role = "review";
    if (success) {
      if (role === 'upload') {
        navigate('/upload-docs');
      
      } else if (role === 'review' || role === 'admin') {
        navigate('/review');
      
      }
    } else {
      setError('Invalid username or password.');
    }
  };

  return (
   (!isAuthenticated && !loading)  && <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="80vh" bgcolor="#f5f5f5">
      <Paper elevation={3} style={{ padding: '40px', maxWidth: '400px', width: '100%' }}>
        <Typography variant="h4" component="h1" gutterBottom style={{ marginTop: '24px' }}>
          Login
        </Typography>

        {error && <Alert severity="error" style={{ marginBottom: '20px' }}>{error}</Alert>}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            margin="normal"
            required
          />

          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                color="primary"
              />
            }
            label="Remember Me"
          />

          <Button variant="contained" color="primary" type="submit" fullWidth style={{ marginTop: '20px' }}>
            Sign in
          </Button>
           
          <MicrosoftSSOButton onClick={loginSSO} />
        
        </form>
      </Paper>
    </Box>
  );
}

export default LoginPage;
